// extracted by mini-css-extract-plugin
module.exports = {"button-with-icon":"ButtonWithIcon_button-with-icon__o1OrK","icon":"ButtonWithIcon_icon___Pu0N"};